import { render, staticRenderFns } from "./BookingResourceCreateEdit.vue?vue&type=template&id=641244b8&"
import script from "./BookingResourceCreateEdit.vue?vue&type=script&lang=ts&"
export * from "./BookingResourceCreateEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports